// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#2b88ff","colorPrimaryEnd":"#1955a8","colorBg":"#f5f5f5","colorText1":"#333","colorText2":"#666","colorText3":"#999","test":"theme_test__LAbTj"};